import { IconHomeOwner, IconElectrician } from '../components/icons'

export enum UserType {
  Consumer = 'consumer',
  Electrician = 'electrician',
}

export function getUserTypeDisplayName(userType: UserType): string {
  switch (userType) {
    case UserType.Consumer: return 'Home Owner'
    case UserType.Electrician: return 'Electrician'
  }
}

export function getUserTypeIcon(userType: UserType): string {
  switch (userType) {
    case UserType.Consumer: return IconHomeOwner
    case UserType.Electrician: return IconElectrician
  }
}